// const wbToken = "eyJhbGciOiJFUzI1NiIsImtpZCI6IjIwMjUwOTA0djEiLCJ0eXAiOiJKV1QifQ.eyJhY2MiOjEsImVudCI6MSwiZXhwIjoxNzg1MzQ3MjA2LCJpZCI6IjAxOWMwMzIzLWQ3YWQtN2FiYi1iYWJiLTRjMTFjMWQwNDZlNCIsImlpZCI6MzA5MDExMTI0LCJvaWQiOjI1MDA5OTA2NCwicyI6Njk0LCJzaWQiOiJiNTNkZjJjNy00MTM0LTQyOGEtOWJmMS00ODQyZmE1ZGExZTMiLCJ0IjpmYWxzZSwidWlkIjozMDkwMTExMjR9.T6C1mmBOnhatj-n13XagRAHPdx8e9InN4GqmHU5QbMcmXnH-kIHYU9ofNDUe93Nyn6LWqCPjZL7yqDCMbRTCjg";

import { useAuthStore } from "@/stores/auth";

export const wbFetch = (url: string, method: "GET" | "POST", data: any = null) => {
  const authStore = useAuthStore();

  return fetch(url, {
    method,
    body: data,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authStore.marketplaceConnections.wildberries.token}`,
    },
  }).then((res) => res.json());
};
